'use client';

import React from 'react';
import ImageMarqueeBlockElement from '@/components/home/sections/PortalGallery/ImageMarqueeBlockElement';
import { motion } from 'motion/react';

export interface ImageData {
  url: string;
  title: string;
}

interface ImageMarqueeBlockProps {
  imagesData: ImageData[];
}

const ImageMarqueeBlock: React.FC<ImageMarqueeBlockProps> = ({ imagesData }) => {
  return (
    <section
      className="flex w-[90%] justify-between overflow-hidden"
      style={{
        maskImage:
          'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 12.5%, rgb(0, 0, 0) 87.5%, rgba(0, 0, 0, 0) 100%)',
      }}
    >
      <motion.div
        animate={{
          x: ['0%', '-2744px'],
          transition: {
            ease: 'linear',
            duration: 60,
            repeat: Infinity,
          },
        }}
        className="flex flex-shrink-0 justify-between gap-[96px]"
      >
        {[...imagesData, ...imagesData].map((item, i) => (
          <ImageMarqueeBlockElement key={i} image={item} />
        ))}
      </motion.div>
    </section>
  );
};

export default ImageMarqueeBlock;
